module.exports = __webpack_public_path__ + "img/hr-H-T-5-unload-standup-shadow.445d5a31.png";